function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M471.24,14.054H40.749C18.281,14.054,0,32.332,0,54.803v59.224c0,4.602,3.731,8.332,8.332,8.332 c4.602,0,8.332-3.731,8.332-8.332V54.803c0-13.281,10.805-24.085,24.085-24.085h430.49c13.287,0,24.096,10.805,24.096,24.085 v284.412h-32.462v-103.01c0-16.17-13.155-29.324-29.324-29.324H312.226c-16.17,0-29.324,13.155-29.324,29.324v159.036H40.749 c-13.28,0-24.085-10.805-24.085-24.085v-15.275H263.46c4.602,0,8.332-3.731,8.332-8.332c0-4.602-3.731-8.332-8.332-8.332H16.664 V141.801c0-4.602-3.731-8.332-8.332-8.332C3.731,133.469,0,137.2,0,141.801v229.354c0,22.47,18.281,40.749,40.749,40.749h142.787 l-20.495,47.948h-40.027c-4.602,0-8.332,3.731-8.332,8.332c0,4.602,3.731,8.332,8.332,8.332h45.526h92.856h1.111 c4.602,0,8.332-3.731,8.332-8.332c0-4.602-3.731-8.332-8.332-8.332h-1.111h-80.233l14.241-33.317h87.497v42.086 c0,16.17,13.155,29.324,29.324,29.324h121.323c16.17,0,29.324-13.155,29.324-29.324V355.879h32.462v15.275 c0,9.701-5.778,18.413-14.72,22.196c-4.238,1.793-6.221,6.681-4.428,10.919c1.344,3.18,4.43,5.089,7.678,5.089 c1.082,0,2.183-0.212,3.242-0.66c15.121-6.396,24.892-21.132,24.892-37.543V54.803C512,32.332,493.715,14.054,471.24,14.054z  M299.564,236.205L299.564,236.205c0.001-6.981,5.68-12.66,12.661-12.66h121.323c6.981,0,12.66,5.679,12.66,12.66V430.18H299.564 V236.205z M446.21,468.623c0,6.98-5.679,12.66-12.661,12.66H312.226c-6.981,0-12.66-5.679-12.66-12.66v-21.779H446.21V468.623z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M262.924,368.955c-3.987-6.049-13.707-4.123-15.098,3c-0.672,3.44,0.933,7.043,3.962,8.811 c3.025,1.765,6.959,1.424,9.621-0.855C264.589,377.189,265.22,372.441,262.924,368.955z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M380.584,460.874c-1.324-3.138-4.479-5.226-7.901-5.138c-3.412,0.087-6.483,2.309-7.633,5.519 c-1.173,3.277-0.134,7.034,2.553,9.246c2.799,2.304,6.888,2.494,9.904,0.494C380.799,468.811,382.043,464.517,380.584,460.874z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M395.662,233.543h-45.549c-4.602,0-8.332,3.731-8.332,8.332c0,4.602,3.731,8.332,8.332,8.332h45.549 c4.602,0,8.332-3.731,8.332-8.332C403.994,237.273,400.264,233.543,395.662,233.543z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var SvgDigital = function SvgDigital(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.998 511.998",
    style: {
      enableBackground: "new 0 0 511.998 511.998"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDigital, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/digital.cb7ce9ab.svg";
export { ForwardRef as ReactComponent };